/* The native Shopify discount is the source of truth. This guide never sets prices. */
(() => {
  'use strict';
  const dialog = document.getElementById('mz-bogo-picker');
  if (!dialog) return;
  const root = dialog.dataset.root.replace(/\/?$/, '/');
  const money = value => new Intl.NumberFormat('en-PK', {style:'currency',currency:dialog.dataset.currency || 'PKR',maximumFractionDigits:0}).format(value / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const status = document.getElementById('mz-bogo-status');
  const products = document.getElementById('mz-bogo-products');
  const search = document.getElementById('mz-bogo-search');
  const category = document.getElementById('mz-bogo-category');
  let currentCart, catalog, loadingCatalog, opener, busy = false, opening = 0;

  async function getCart() {
    const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error('Your cart could not be loaded. Please try again.');
    return response.json();
  }
  function state(cart) {
    const items = cart.items.filter(item => !item.gift_card && item.original_price > 0);
    const count = items.reduce((sum,item) => sum + item.quantity, 0);
    const prices = items.slice().sort((a,b) => b.original_price - a.original_price);
    let position = Math.floor(count / 2), cap = 0;
    for (const item of prices) { if (position < item.quantity) { cap = item.original_price; break; } position -= item.quantity; }
    let free = 0, savings = 0;
    for (const item of items) {
      const discounts = item.line_level_discount_allocations || [];
      const amount = discounts.reduce((sum,d) => /buy\s*1\s*get\s*1|bogo/i.test(d.discount_application?.title || '') ? sum + d.amount : sum, 0);
      savings += amount;
      free += Math.min(item.quantity, Math.floor(amount / item.original_price));
    }
    return {count, cap, pending:count % 2 === 1, free, savings};
  }
  function renderCart(cart) {
    currentCart = cart;
    const s = state(cart);
    document.querySelectorAll('[data-mz-cart-progress]').forEach(box => {
      box.hidden = !s.count;
      if (!s.count) return;
      const headline = s.pending ? 'You can choose 1 more free item' : s.free ? `${s.free} free ${s.free === 1 ? 'item' : 'items'} added to your cart` : 'Buy 1, get 1 free';
      const detail = s.pending ? 'Choose your free item before checking out.' : s.free ? `You saved ${money(s.savings)}. Your discount is already included below.` : 'Add any 2 eligible items. The lower-priced item becomes free automatically.';
      const shipping = cart.currency === 'PKR' ? (cart.total_price >= 1200000 ? 'Free Pakistan shipping unlocked.' : `${money(1200000 - cart.total_price)} away from free Pakistan shipping.`) : 'Free Pakistan shipping on Rs 12,000+ after discounts.';
      box.innerHTML = `<strong>${escape(headline)}</strong><p>${escape(detail)}</p>${s.pending ? '<button type="button" data-mz-choose>Choose my free item</button>' : ''}<small>${escape(shipping)} Calculated after discounts.</small>`;
    });
    if (dialog.open && !busy) renderProducts();
  }
  async function loadCatalog() {
    if (catalog) return catalog;
    if (loadingCatalog) return loadingCatalog;
    loadingCatalog = (async () => {
      let url = dialog.dataset.catalog, all = [], pages = 0;
      while (url && pages++ < 20) {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Products could not be loaded. Please try again.');
        const data = await response.json();
        all = all.concat(data.products);
        url = data.next;
        if (url) { const next = new URL(url, location.origin); next.searchParams.set('view','muzaree-bogo'); url = next.pathname + next.search; }
      }
      catalog = all.filter(p => !p.giftCard);
      [...new Set(catalog.map(p => p.type).filter(Boolean))].sort().forEach(type => category.add(new Option(type,type)));
      return catalog;
    })().catch(error => { loadingCatalog = null; throw error; });
    return loadingCatalog;
  }
  function renderProducts() {
    if (!catalog || !currentCart) return;
    const s = state(currentCart);
    document.getElementById('mz-bogo-title').textContent = s.pending ? 'Choose your free item' : 'Choose your first item';
    document.getElementById('mz-bogo-intro').textContent = s.pending
      ? `Your item has been added. Pick any item below for FREE, then choose its size or style. No code needed.`
      : 'Add any 2 eligible items to your cart. The lower-priced item becomes free. Buy 2, get 2 free — no code needed.';
    const query = search.value.trim().toLowerCase();
    const matches = catalog.map(p => ({...p, choices:p.variants.filter(v => v.available && v.price > 0 && (!s.pending || v.price <= s.cap))}))
      .filter(p => p.choices.length && (!category.value || p.type === category.value) && (!query || (p.title + ' ' + p.type).toLowerCase().includes(query)))
      .sort((a,b) => Math.min(...b.choices.map(v => v.price)) - Math.min(...a.choices.map(v => v.price)));
    status.textContent = `${matches.length} ${matches.length === 1 ? 'product' : 'products'} ${s.pending ? 'available for your free item' : 'available'}.`;
    products.innerHTML = matches.length ? matches.map(p => {
      const variant = p.choices[0];
      const standard = p.choices.length === 1 && variant.title === 'Default Title';
      const optionName = p.type === 'Shoes' || p.choices.every(v => /^\d+\//.test(v.title)) ? 'size' : 'style';
      const choice = standard ? `<input type="hidden" data-mz-variant value="${variant.id}">` : `<label>Choose your ${optionName}<select data-mz-variant aria-label="Size or style for ${escape(p.title)}"><option value="">Select ${optionName}</option>${p.choices.map(v => `<option value="${v.id}">${escape(v.title)}</option>`).join('')}</select></label>`;
      return `<article class="mz-bogo-card" data-product="${p.id}" data-choice="${optionName}"><img src="${escape(p.image)}" alt="${escape(p.title)}" loading="lazy" width="360" height="360"><div class="mz-bogo-card-body"><h3><a href="${escape(p.url)}">${escape(p.title)}</a></h3><p data-mz-price>${s.pending ? `<s>${escape(money(variant.price))}</s> <span class="mz-bogo-free">FREE</span>` : escape(money(variant.price))}</p>${choice}<button class="mz-bogo-add" type="button" data-mz-add ${standard ? '' : 'disabled'}>${standard ? (s.pending ? 'Add free item' : 'Add item') : `Choose ${optionName} first`}</button></div></article>`;
    }).join('') : '<p>No matching products. Try another category or search.</p>';
  }
  async function openPicker(source) {
    const request = ++opening;
    opener = source || document.activeElement;
    document.querySelectorAll('.js-mini-cart.active').forEach(el => el.classList.remove('active'));
    if (!dialog.open) dialog.showModal();
    status.textContent = 'Loading your choices…';
    products.innerHTML = '';
    try {
      const [cart] = await Promise.all([getCart(),loadCatalog()]);
      if (request !== opening || !dialog.open) return;
      renderCart(cart);
      renderProducts();
    } catch (error) {
      status.textContent = error.message || 'Unable to load products. Please try again.';
      products.innerHTML = `<p><a href="${escape(dialog.dataset.catalog.split('?')[0])}">Browse all products</a> or <a href="${escape(dialog.dataset.cart)}">view your cart</a>.</p>`;
    }
  }
  function closePicker() { if (!busy) dialog.close(); }
  dialog.addEventListener('close', () => { opening++; if (opener?.isConnected) opener.focus(); });
  dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
  document.addEventListener('click', event => {
    const choose = event.target.closest('[data-mz-choose]');
    if (choose) { event.preventDefault(); openPicker(choose); }
    if (event.target.closest('[data-mz-close]')) closePicker();
  });
  search.addEventListener('input',renderProducts);
  category.addEventListener('change',renderProducts);
  products.addEventListener('change', event => {
    const card = event.target.closest('[data-product]');
    if (!card) return;
    const product = catalog.find(p => String(p.id) === card.dataset.product);
    const variant = product.variants.find(v => String(v.id) === event.target.value);
    const button = card.querySelector('[data-mz-add]');
    button.disabled = !variant;
    button.textContent = variant ? (state(currentCart).pending ? 'Add free item' : 'Add item') : `Choose ${card.dataset.choice} first`;
    if (variant) card.querySelector('[data-mz-price]').innerHTML = state(currentCart).pending ? `<s>${escape(money(variant.price))}</s> <span class="mz-bogo-free">FREE</span>` : escape(money(variant.price));
  });
  products.addEventListener('click', async event => {
    const button = event.target.closest('[data-mz-add]');
    if (!button || busy) return;
    const card = button.closest('[data-product]');
    const variantId = Number(card.querySelector('[data-mz-variant]').value);
    if (!variantId) return;
    const label = button.textContent;
    let added = false;
    busy = true;
    products.querySelectorAll('button,select').forEach(el => el.disabled = true);
    button.textContent = 'Adding…';
    status.textContent = '';
    try {
      const before = await getCart();
      const was = state(before), selected = catalog.flatMap(p => p.variants).find(v => v.id === variantId);
      if (was.pending !== state(currentCart).pending || (was.pending && selected.price > was.cap)) {
        renderCart(before);
        throw new Error('Your cart changed. Please review your choices again.');
      }
      const response = await fetch(root + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1}]})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This size is no longer available. Please choose another.');
      added = true;
      const after = await getCart();
      renderCart(after);
      busy = false;
      if (document.body.classList.contains('template-cart')) { location.reload(); return; }
      if (was.pending && state(after).free <= was.free) {
        status.textContent = 'Item added. The free-item discount was not confirmed; please review your cart before checkout.';
        renderProducts();
        status.textContent = 'Item added. The free-item discount was not confirmed; please review your cart before checkout.';
      } else if (state(after).pending) {
        renderProducts();
      } else {
        dialog.close();
        window.theme?.miniCart?.updateElements();
        window.theme?.miniCart?.generateCart();
      }
    } catch (error) {
      busy = false;
      if (added) {
        products.innerHTML = `<p>Your item was added, but the cart could not be refreshed. <a href="${escape(dialog.dataset.cart)}">Review your cart</a> before adding it again.</p>`;
        status.textContent = 'Item added. Please review your cart.';
      } else {
        renderProducts();
        status.textContent = error.message || 'Could not add this item. Please try again.';
      }
      button.textContent = label;
    } finally {
      busy = false;
      products.querySelectorAll('select').forEach(el => el.disabled = false);
      products.querySelectorAll('[data-mz-add]').forEach(el => el.disabled = !el.closest('[data-product]').querySelector('[data-mz-variant]').value);
    }
  });
  window.MuzareeBogo = {
    renderCart,
    afterAdd: async () => { try { const cart = await getCart(); renderCart(cart); if (state(cart).pending) openPicker(document.querySelector('.product-form__cart-submit')); } catch (_) { /* Native cart stays usable. */ } }
  };
  document.querySelectorAll('.product-form__cart-submit').forEach(button => {
    if (button.tagName === 'BUTTON' && !button.disabled) {
      const text = button.querySelector('[id^="AddToCartText-"]');
      if (text) text.textContent = 'Add & choose free item';
    }
  });
  if (window.jQuery) window.jQuery('[data-section-type^="product"]').on('variantChange.muzaree', () => {
    setTimeout(() => document.querySelectorAll('[id^="AddToCartText-"]').forEach(text => { if (!text.closest('button').disabled) text.textContent = 'Add & choose free item'; }),0);
  });
  getCart().then(renderCart).catch(() => {});
})();
